module.exports = __webpack_public_path__ + "static/media/lotus.e3b0d27b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lotus.svg
// module id = 567
// module chunks = 0